import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Download, Printer, Globe, Infinity } from 'lucide-react';
const CHECKOUT_URL = 'https://noveliahub.com/cart/50875095482404:1';
export function Hero() {
  const handleCheckout = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
  };
  const benefits = [{
    icon: Globe,
    text: 'Español + English'
  }, {
    icon: Printer,
    text: 'Imprime en casa'
  }, {
    icon: BookOpen,
    text: '+100 páginas'
  }, {
    icon: Download,
    text: 'Edades 2-6'
  }, {
    icon: Infinity,
    text: 'Imprime ilimitado'
  }];
  return <section className="relative w-full bg-gradient-to-b from-orange-50 via-amber-50 to-white py-16 md:py-24" data-id="element-93">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-95">
          <h1 className="font-fredoka text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-1" data-id="element-96">
            ¿Tu hijo pasa horas pegado al celular?
          </h1>
          <p className="font-fredoka text-xl sm:text-2xl md:text-3xl text-gray-500 italic mb-8" data-id="element-97">
            Is your child glued to the screen?
          </p>
          <p className="font-fredoka text-2xl sm:text-3xl md:text-4xl font-semibold text-orange-600 mb-1" data-id="element-98">
            Descubre el libro de actividades que los niños PIDEN imprimir una y
            otra vez
          </p>
          <p className="font-fredoka text-lg sm:text-xl md:text-2xl text-orange-400 italic mb-8" data-id="element-99">
            Discover the activity book kids BEG to print over and over again
          </p>

          <p className="text-lg sm:text-xl text-gray-700 max-w-3xl mx-auto mb-3 leading-relaxed" data-id="element-100">
            Más de 100 actividades bilingües (español + inglés) para niños de 2
            a 6 años. Imprime en casa. Juega sin pantallas. Aprende sin darse
            cuenta.
          </p>
          <p className="font-nunito text-base sm:text-lg text-gray-500 italic max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-101">
            Over 100 bilingual activities (Spanish + English) for kids ages 2 to
            6. Print at home. Play screen-free. Learn without even trying.
          </p>

          <motion.a href={CHECKOUT_URL} onClick={handleCheckout} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-orange-500 hover:bg-orange-600 text-white font-nunito font-bold text-xl px-12 py-5 rounded-full shadow-lg hover:shadow-xl transition-all mb-12 inline-block" data-id="element-102">
            COMPRAR AHORA / BUY NOW — $6.36
          </motion.a>

          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 max-w-4xl mx-auto" data-id="element-103">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1 * index,
            duration: 0.4
          }} className="flex items-center gap-2 bg-white px-4 py-3 rounded-full shadow-md" data-id="element-104">
                <benefit.icon className="w-5 h-5 text-orange-500" data-id="element-105" />
                <span className="font-nunito font-semibold text-gray-800 text-sm sm:text-base" data-id="element-106">
                  {benefit.text}
                </span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.6,
          duration: 0.6
        }} className="mt-16" data-id="element-107">
            <img src="https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&q=80" alt="Niños felices haciendo actividades del libro imprimible" className="rounded-3xl shadow-2xl mx-auto max-w-full md:max-w-3xl" data-id="element-108" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}